<template>
    <div>
        <span>{{ getActorName }} kullanıcısı "{{ $_.get(activity, 'payload.taskTitle') }}" adlı görevden şu etiketleri kaldırdı: {{ $_.get(activity, 'payload.tags').join(', ') }}<span v-if="ruleSource"> (<em>{{ ruleSource }}</em> aracılığıyla)</span>.</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskRemovedTags",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        getActorName() {
            const actorName = this.$_.get(this.activity, "actorUser.name");
            if (actorName) return actorName;
            if (this.$_.get(this.activity, "actor") === "system") return "Sistem";
            return "Bilinmeyen";
        },
        ruleSource() {
            return this.$_.get(this.activity, "payload.ruleSource");
        }
    }
});
</script>
<style scoped lang="scss"></style>
